var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D3EAFF;}\r\n\t.st1{fill:none;stroke:#278DEC;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,23.7L12,23.7C5.5,23.7,0.3,18.5,0.3,12l0,0C0.3,5.5,5.5,0.3,12,0.3l0,0c6.5,0,11.7,5.2,11.7,11.7l0,0 C23.7,18.5,18.5,23.7,12,23.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.3,11.4H9.5 M10.7,13.9H9.5 M14.5,8.9h-5 M17,8.7v6.5c0,1.1,0,1.6-0.2,2c-0.2,0.4-0.5,0.6-0.8,0.8 c-0.4,0.2-0.9,0.2-2,0.2h-4c-1.1,0-1.6,0-2-0.2c-0.4-0.2-0.6-0.5-0.8-0.8C7,16.8,7,16.3,7,15.3V8.7c0-1.1,0-1.6,0.2-2 C7.4,6.4,7.7,6.1,8,6c0.4-0.2,0.9-0.2,2-0.2h4c1.1,0,1.6,0,2,0.2c0.4,0.2,0.6,0.5,0.8,0.8C17,7.2,17,7.7,17,8.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogsIcon);
export default __webpack_public_path__ + "static/media/logsIcon.10789b2cee77a6362289e2c37e9da2ff.svg";
export { ForwardRef as ReactComponent };